import {ReactNode, useEffect} from 'react';
import ButtonSolid from 'components/Buttons/ButtonSolid';
import {surveyInstance} from 'screens/InsomniaSurvey/InsomniaSurvey';
import Analytics from 'utils/Analytics';
import {readSeverityFromUrl} from 'surveys/osa_funnel/survey/severity';
import {ScienceCallout} from '../ScienceCallout/ScienceCallout';
import styles from './ScienceScreen.module.css';

export type ScienceScreenProps = {
  headline?: ReactNode;
  body: ReactNode;
  animation: ReactNode;
  calloutLabel?: string;
  callout?: ReactNode;
  /** When true, body renders below the animation (used by Acceptance). */
  bodyAfterAnimation?: boolean;
  analyticsShown: string;
  analyticsSubmitted: string;
};

export const ScienceScreen = ({
  headline,
  body,
  animation,
  calloutLabel,
  callout,
  bodyAfterAnimation = false,
  analyticsShown,
  analyticsSubmitted,
}: ScienceScreenProps) => {
  const severity = readSeverityFromUrl();

  useEffect(() => {
    Analytics.track(analyticsShown, {severity});
  }, [analyticsShown, severity]);

  const handleNext = () => {
    Analytics.track(analyticsSubmitted, {severity});
    if (surveyInstance.isLastPage) {
      surveyInstance.completeLastPage();
    } else {
      surveyInstance.nextPage();
    }
  };

  return (
    <div className={styles.container} data-testid="osa-science">
      <p className={styles.prelude}>What the science says:</p>
      {headline ? <h2 className={styles.headline}>{headline}</h2> : null}
      {bodyAfterAnimation ? (
        <>
          <div className={styles.animation}>{animation}</div>
          <div className={styles.copy}>{body}</div>
        </>
      ) : (
        <>
          <div className={styles.copy}>{body}</div>
          <div className={styles.animation}>{animation}</div>
        </>
      )}
      {callout ? <ScienceCallout label={calloutLabel}>{callout}</ScienceCallout> : null}
      <div className={styles.cta}>
        <ButtonSolid title="Next" onClick={handleNext} />
      </div>
    </div>
  );
};

export default ScienceScreen;
